"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSizeString = exports.createArtworkProductPreviewUrl = void 0;
const paths_1 = require("../consts/paths");
function createArtworkProductPreviewUrl(categoryName, artworkId) {
    return paths_1.ARTWORK_VIEW_URL
        .replace(':category', categoryName)
        .replace(':artworkId', artworkId);
}
exports.createArtworkProductPreviewUrl = createArtworkProductPreviewUrl;
const getSizeString = (size) => `${size.width}X${size.height}`;
exports.getSizeString = getSizeString;
//# sourceMappingURL=artUtils.js.map